var _radialGradient, _circle, _path, _path2, _path3, _path4, _radialGradient2, _path5, _radialGradient3, _path6, _radialGradient4, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngryFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q5Ps0mrGixQ_Me5OWfJPLa",
    cx: -792,
    cy: 24,
    r: 18,
    fx: -792.095,
    fy: 16.289,
    gradientTransform: "translate(816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffd426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fdcd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#f8b919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09c0c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#q5Ps0mrGixQ_Me5OWfJPLa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.828,21.172c1.562,1.562,1.562,4.095,0,5.657c-1.562,1.562-4.095,1.562-5.657,0 c0,0,0.559-1.973,2.121-3.536C30.855,21.731,32.828,21.172,32.828,21.172z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M28.148,24.755c0.098,0.24,0.244,0.465,0.438,0.659c0.781,0.781,2.047,0.781,2.828,0 c0.781-0.781,0.781-2.047,0-2.828c-0.195-0.195-0.419-0.341-0.659-0.438c-0.482,0.301-0.989,0.672-1.462,1.145 C28.82,23.766,28.449,24.273,28.148,24.755z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.172,21.172c-1.562,1.562-1.562,4.095,0,5.657c1.562,1.562,4.095,1.562,5.657,0 c0,0-0.559-1.973-2.121-3.536C17.145,21.731,15.172,21.172,15.172,21.172z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M19.852,24.755c-0.098,0.24-0.244,0.465-0.438,0.659c-0.781,0.781-2.047,0.781-2.828,0 c-0.781-0.781-0.781-2.047,0-2.828c0.195-0.195,0.419-0.341,0.659-0.438c0.482,0.301,0.989,0.672,1.462,1.145 C19.18,23.766,19.551,24.273,19.852,24.755z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q5Ps0mrGixQ_Me5OWfJPLb",
    cx: 54.619,
    cy: -4.469,
    r: 3.326,
    gradientTransform: "matrix(.0157 1.116 -3.2952 .1212 8.414 -29.701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#ffe16e",
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q5Ps0mrGixQ_Me5OWfJPLb)",
    d: "M19.17,33.252c0,0,1.116,0.748,4.83,0.748c3.44,0,4.827-0.748,4.827-0.748 s-0.863-1.485-4.827-1.485S19.17,33.252,19.17,33.252z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q5Ps0mrGixQ_Me5OWfJPLc",
    cx: 117.927,
    cy: -1071.793,
    r: 8.277,
    gradientTransform: "matrix(-.618 0 0 -.3776 96.897 -372.926)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q5Ps0mrGixQ_Me5OWfJPLc)",
    d: "M24,33c3.392,0,4.31,0.609,4.31,0.609S27.43,35,24,35s-4.31-1.391-4.31-1.391S20.608,33,24,33 z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q5Ps0mrGixQ_Me5OWfJPLd",
    cx: -898.878,
    cy: -853.625,
    r: 15.654,
    gradientTransform: "matrix(.35 0 0 -.1877 338.596 -127.667)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q5Ps0mrGixQ_Me5OWfJPLd)",
    d: "M28.701,33.195c0.501,0.276,0.995-0.358,0.608-0.779C28.185,31.194,26.458,30,24,30 s-4.185,1.194-5.309,2.416c-0.387,0.421,0.107,1.055,0.608,0.779C20.45,32.559,22.024,32,24,32S27.55,32.559,28.701,33.195z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#805b2a",
    d: "M35.5,21.019c-0.912,0.046-1.804,0.089-2.616,0.269c-0.814,0.175-1.52,0.531-2.131,1.039 c-0.612,0.508-1.126,1.169-1.582,1.881c-0.469,0.704-0.854,1.491-1.267,2.258l-0.019,0.036c-0.266,0.494-0.883,0.678-1.377,0.412 c-0.494-0.266-0.678-0.883-0.412-1.377l0.002-0.004c0.454-0.833,0.94-1.653,1.554-2.417c0.607-0.761,1.299-1.496,2.156-2.072 c0.85-0.578,1.871-0.95,2.858-1.054c0.989-0.113,1.927-0.054,2.835-0.01c0.287,0.014,0.508,0.258,0.494,0.544 C35.981,20.794,35.763,21.005,35.5,21.019z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#805b2a",
    d: "M12.5,19.981c0.908-0.044,1.847-0.103,2.835,0.01c0.987,0.104,2.007,0.476,2.858,1.054 c0.857,0.576,1.549,1.31,2.156,2.072c0.614,0.765,1.099,1.584,1.554,2.417c0.269,0.493,0.087,1.11-0.405,1.379 c-0.493,0.269-1.11,0.087-1.379-0.405l-0.002-0.004l-0.019-0.036c-0.414-0.767-0.799-1.555-1.267-2.258 c-0.457-0.712-0.971-1.373-1.582-1.881c-0.611-0.508-1.316-0.864-2.131-1.039c-0.813-0.18-1.705-0.223-2.616-0.269 c-0.287-0.014-0.508-0.258-0.494-0.544C12.019,20.206,12.237,19.995,12.5,19.981z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryFace);
export default __webpack_public_path__ + "static/media/angry-face.231a983d9d01c0d6e7ccac1fe469df79.svg";
export { ForwardRef as ReactComponent };